/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import url from 'url';
import omit from 'lodash/omit';

/**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */

const stripQueryParams = (paramsToStrip: string[]): void => {
	try {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const parsedUrl = url.parse(window.location.href, true);
		const strippedQuery = omit(parsedUrl.query || {}, paramsToStrip);
		let strippedUrl = url.format({ ...parsedUrl, search: undefined, query: strippedQuery });

		// we don't want to encode : to %3A in connect project pages
		const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.location.search,
		);

		if (isConnect) {
			strippedUrl = strippedUrl.replace(
				/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g,
				(match) => match.replace(/%3A/i, ':'),
			);
		}

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.history.replaceState({}, '', strippedUrl);
	} catch (e) {
		/* uri might be malformed */
	}
};

export default stripQueryParams;
